// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "hashed-1/" + "griffel" + "-" + "059f00c0ac" + ".css";
};